import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />

      <main className="shop__main">
        <section className="shop__intro">
          <div className="shop__inner">
            <h1 className="shop__title">Shop All</h1>
            <p className="shop__lead">
              Personal care products designed to reduce single-use plastic waste
              in your daily routine. Kind to your body & our planet.
            </p>
          </div>
        </section>

        <section className="shop__grid">
          <div className="shop__inner">
            <div className="products-grid">
              {productData.map((p) => (
                <Link
                  key={p.id}
                  to={`/shopDetails/${p.id}`}
                  onClick={toTop}
                  className="product-card"
                  style={{ backgroundImage: `url('${p.image}')` }}
                >
                  <div className="product-card__overlay">
                    <div className="product-card__title">{p.name}</div>
                    <div className="product-card__price">${p.price}</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
